import { AssigneeDto } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/AssigneeDto';
import { getEditorListData } from 'components/property-editors/utils/EditorConfigurationUtils';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties/ContextProviderNode';
import {
  AssigneesHolder,
  newAssigneesHolder,
} from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/AssigneesHolder';
import {
  getByStates,
  getByType,
  getUserEmail,
  getFolderRight,
  getGroupName,
} from 'components/assignments/utils/AssignmentUtils';
import { State } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/State';
import { AssigneeType } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/AssigneeType';

export function getAssignees(child: ContextProviderNode, deleted?: Map<number, AssigneeDto>): AssigneeDto[] {
  const listData = getEditorListData<AssigneeDto[]>(child) || [];
  const ids = listData.map(d => d.Id);
  if (deleted) {
    deleted.forEach((dto, i) => {
      if (ids.includes(dto.Id)) {
        // during loading / multiple renders, can hit a situation where there's only one deleted, and it shows two copies of it
        // TODO eventually sort out why some of these editors re-render too many times.
        return;
      }
      i = Math.min(i, listData.length);
      listData.splice(i, 0, dto);
    });
  }
  return listData;
}

export function convertServerValue(assignees: AssigneeDto[]): AssigneesHolder {
  const states = getByStates(assignees, State.Added, State.Initial);
  const emails = getByType(states, AssigneeType.Account).map(item => getUserEmail(item));
  const rolesIds = getByType(states, AssigneeType.Role).map(item => item.Id);
  const folderRights = getByType(states, AssigneeType.AssignmentFolderRights).map(item => getFolderRight(item));
  const groupsNames = getByType(states, AssigneeType.Group).map(item => getGroupName(item));

  return newAssigneesHolder({
    EmailsAccounts: emails,
    IdsRoles: rolesIds,
    FolderRights: folderRights,
    NamesGroups: groupsNames,
  });
}

export function getDeletedAssignees(assignees: AssigneeDto[]) {
  const deleted = new Map<number, AssigneeDto>();
  assignees.forEach((assignee, i) => {
    if (assignee.State === State.Removed) {
      deleted.set(i, assignee);
    }
  });
  return deleted;
}
